// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useLazyGetUserProfileQuery } from 'services/userApi';
import { useEffect } from 'react';
import { get_user, set_user } from 'utils/functions';
import { useRoleBasedPermissionsListingQuery } from 'services/roles-management/permissions/permissions-api';
import { useState } from 'react';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const {data} = useRoleBasedPermissionsListingQuery() 
  // const [trigger] = useLazyGetUserProfileQuery();
  // const [userData, setUserData] = useState(null);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const { data } = await trigger(1);
  //       setUserData(data);
  //       set_user(data);
  //     } catch (error) {
  //     }
  //   };
  //   fetchData();
  // }, []);

  const userData = get_user();


 const dashboardItem = menuItem?.items?.find(item => item?.id === 'dashboard');
 const isSuperAdmin = userData?.role === 'Super Admin' ;
    
  const navItems = menuItem?.items?.map((item) => {

 const filteredChildren = item?.children?.filter((child) => (data?.role?.permissions?.includes(child?.check)));
 const hasPermission = filteredChildren && filteredChildren.length > 0;

    switch (item.type) {
      case 'group': 
      return (((isSuperAdmin || hasPermission)) && <NavGroup key={item.id} item={ isSuperAdmin ? item : { ...item, children: filteredChildren }} /> );
      // return item?.userRoles?.includes(userData?.role) && <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });
  if (dashboardItem && !isSuperAdmin ) {
    const dashboardNavItem = <NavGroup key={dashboardItem.id} item={dashboardItem} />;
    navItems.unshift(dashboardNavItem);
  }
  return <>{navItems}</>;
};

export default MenuList;
